<div class="row m-0 pt-1 h-auto">
  <!-- CEP - MUNICIPIO -->
  <div class="flex width-100">
    <div class="flex-column col-md-5 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>CEP</mat-label>
        <input
          matInput
          type="text"
          [formControl]="form.get('cep')"
          mask="00000-000"
          [readonly]="notRequired"
          (blur)="checkCep($event.target.value)"
        />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="
          !readonly &&
          form.get('cep').touched &&
          form.get('cep').hasError('required')
        "
      >
        {{ messages.cep.required }}
      </small>
      <small
        class="p-error"
        *ngIf="
          !readonly &&
          form.get('cep').touched &&
          form.get('cep').hasError('pattern')
        "
      >
        {{ messages.cep.pattern }}
      </small>
      <small
        class="p-error"
        *ngIf="
          !readonly &&
          form.get('cep').touched &&
          form.get('cep').hasError('notFound')
        "
      >
        {{ messages.cep.notFound }}
      </small>
    </div>
    <fast-autocomplete
      #input
      class="col-md-7 mt-3"
      id="field-grupo-pai"
      placeholder="Municipio"
      displayField="nome"
      [control]="form.get('municipio')"
      (clearSelection)="form.get('municipio').setValue('')"
      [entityService]="municipioService"
      [autoFirst]="true"
      [readonly]="true"
      required
      [displayWithEntityFn]="displayFn"
      [messages]="readonly ? {} : messages.municipio"
    ></fast-autocomplete>
  </div>
  <!-- LOGRADOURO - NUMERO -->
  <div class="flex width-100">
    <div class="flex-column col-md-7 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Logradouro </mat-label>
        <input
          #logradouro
          matInput
          type="text"
          [readonly]="notRequired"
          [formControl]="form.get('logradouro')"
        />
      </mat-form-field>

      <small
        class="p-error"
        *ngIf="
          !readonly &&
          form.get('logradouro').touched &&
          form.get('logradouro').hasError('required')
        "
      >
        {{ messages.logradouro.required }}
      </small>
      <small
        class="p-error"
        *ngIf="
          !readonly &&
          form.get('logradouro').touched &&
          form.get('logradouro').hasError('maxlength')
        "
      >
        {{ messages.logradouro.maxlength }}
      </small>
      <small
        class="p-error"
        *ngIf="
          !readonly &&
          form.get('logradouro').touched &&
          form.get('logradouro').hasError('isEmptyValue')
        "
      >
        {{ messages.logradouro.isEmptyValue }}
      </small>
    </div>
    <div class="flex-column col-md-5 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Numero </mat-label>
        <input
          matInput
          type="text"
          [readonly]="notRequired"
          [formControl]="form.get('numero')"
        />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="
          !readonly &&
          form.get('numero').touched &&
          form.get('numero').hasError('required')
        "
      >
        {{ messages.numero.required }}
      </small>
      <small
        class="p-error"
        *ngIf="
          !readonly &&
          form.get('numero').touched &&
          form.get('numero').hasError('maxlength')
        "
      >
        {{ messages.numero.maxlength }}
      </small>
      <small
        class="p-error"
        *ngIf="
          !readonly &&
          form.get('numero').touched &&
          form.get('numero').hasError('pattern')
        "
      >
        {{ messages.numero.pattern }}
      </small>
      <small
        class="p-error"
        *ngIf="
          !readonly &&
          form.get('numero').touched &&
          form.get('numero').hasError('isEmptyValue')
        "
      >
        {{ messages.numero.isEmptyValue }}
      </small>
    </div>
  </div>
  <!-- COMPLEMENTO - BAIRRO -->
  <div class="flex width-100">
    <div class="flex-column col-md-6 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Complemento</mat-label>
        <input
          matInput
          type="text"
          [readonly]="notRequired"
          [formControl]="form.get('complemento')"
        />
      </mat-form-field>

      <small
        class="p-error"
        *ngIf="
          !readonly &&
          form.get('complemento').touched &&
          form.get('complemento').hasError('maxlength')
        "
      >
        {{ messages.complemento.maxlength }}
      </small>
      <small
        class="p-error"
        *ngIf="
          !readonly &&
          form.get('complemento').touched &&
          form.get('complemento').hasError('minlength')
        "
      >
        {{ messages.complemento.minlength }}
      </small>
      <small
        class="p-error"
        *ngIf="
          !readonly &&
          form.get('complemento').touched &&
          form.get('complemento').hasError('isEmptyValue')
        "
      >
        {{ messages.complemento.isEmptyValue }}
      </small>
    </div>
    <div class="flex-column col-md-6 mt-3">
      <mat-form-field class="width-100" appearance="outline">
        <mat-label>Bairro </mat-label>
        <input
          matInput
          type="text"
          [readonly]="notRequired"
          [formControl]="form.get('bairro')"
        />
      </mat-form-field>
      <small
        class="p-error"
        *ngIf="
          !readonly &&
          form.get('bairro').touched &&
          form.get('bairro').hasError('required')
        "
      >
        {{ messages.bairro.required }}
      </small>
      <small
        class="p-error"
        *ngIf="
          !readonly &&
          form.get('bairro').touched &&
          form.get('bairro').hasError('maxlength')
        "
      >
        {{ messages.bairro.maxlength }}
      </small>
      <small
        class="p-error"
        *ngIf="
          !readonly &&
          form.get('bairro').touched &&
          form.get('bairro').hasError('minlength')
        "
      >
        {{ messages.bairro.minlength }}
      </small>
      <small
        class="p-error"
        *ngIf="
          !readonly &&
          form.get('bairro').touched &&
          form.get('bairro').hasError('isEmptyValue')
        "
      >
        {{ messages.bairro.isEmptyValue }}
      </small>
    </div>
  </div>
  <div class="flex-column col-md-12 mt-3">
    <mat-form-field class="width-100" appearance="outline">
      <mat-label>Ponto de referência</mat-label>
      <input
        matInput
        [readonly]="notRequired"
        type="textarea"
        [formControl]="form.get('ponto_referencia')"
        placeholder="Ex: Vizinho a Daminhão..."
      />
    </mat-form-field>
    <small
      class="p-error"
      *ngIf="
        !readonly &&
        form.get('ponto_referencia').touched &&
        form.get('ponto_referencia').hasError('maxlength')
      "
    >
      {{ messages.ponto_referencia.maxlength }}
    </small>
    <small
      class="p-error"
      *ngIf="
        !readonly &&
        form.get('ponto_referencia').touched &&
        form.get('ponto_referencia').hasError('isEmptyValue')
      "
    >
      {{ messages.ponto_referencia.isEmptyValue }}
    </small>
  </div>
</div>
